import { Route, Routes } from "react-router-dom"

import PagosVencidos from "./Pagos/PagosVencidos"
import CotiPendientes from "./Cotizaciones/CotiPendientes"


const ReportesRoutes = () => (
    <Routes>
        <Route path="/Pagos/Vencidos" Component={PagosVencidos} />
        <Route path="/Cotizaciones" Component={CotiPendientes} />
    </Routes>
)

export default ReportesRoutes